export class Bank {
  id: number;
  name: string;
  number: string;
  active: boolean;

  constructor() { }
}
